import { uoUWidgetLoadOnLiveSiteSrc187Evid8 } from '@wix/bi-logger-bookings-data/v2';
import { queryServiceByFormId } from './api/query-service-by-form-id';
export const loadInitialAppointmentData = async ({ httpClient, errorHandler, form, isEditor, bi, signal })=>{
    if (isEditor || !form.id) {
        return {};
    }
    bi?.report(uoUWidgetLoadOnLiveSiteSrc187Evid8({
        widgetName: 'appointment',
        environment: JSON.stringify({
            isEditor
        })
    }));
    const service = await queryServiceByFormId({
        httpClient,
        errorHandler,
        formId: form.id,
        signal
    });
    return {
        service
    };
};

//# sourceMappingURL=load-initial-appointment-data.js.map